/* 
Componente cabezera, aparece en dispositivos web
Es un enrutado para las diferentes paginas
 */

import React from "react";
import { withRouter } from "react-router-dom";

//CONSTANT
import { HREF } from "../constants";

//I18N
import LangSelector from "../i18n/LangSelector";

//REDUX
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "../redux/actions/userActions";

//CSS
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
//ICON
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const StyledBottomNavigationAction = styled(BottomNavigationAction)`
  .MuiBottomNavigationAction-label {
    color: #FFFFFF;
    font-size: 1rem;
    &:hover MuiBottomNavigationAction-label: none
  }
  .MuiBottomNavigationAction-label:hover {
    color: #DF7D44;
  }
  .MuiBottomNavigationAction-label.Mui-selected {
    color: #DF7D44;
    font-size: 1rem;
  }
`;

const useStyles = makeStyles({
  root: {
    backgroundColor: "#363636",
    padding: "8px"
  },
  navigation: {
    height: "auto",
    backgroundColor: "#363636",
    //paddingTop: "15px"
  },
  bottomNavigationAction: {
    padding: "0px !important",
    maxWidth: "180px",
  }
});

function FullWidthTabs({ history }) {
  const classes = useStyles();
  const [tab, setTab] = React.useState(0);

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  const logout = () => dispatch(logoutAction());
  const user = useSelector(state=>state.user.user)
  //#endregion

  //#region OnClick
  const onClickLogout = () => {
    logout()
      .then(() => {
        history.push("/");
      })
      .catch(error => {
        console.log("error logout");
      });
  };

  //#endregion

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item md={2} lg={2}>
        <Box textAlign="center">
          <img
            alt="Logo"
            height="55px"
            src={`${process.env.PUBLIC_URL}/assets/img/logo_V2.png`}
            title="Logo"
            //className="pt-2"
          />
        </Box>
      </Grid>
      <Grid item md={8} lg={7}>
        <BottomNavigation
          value={tab}
          onChange={(event, newValue) => {
            setTab(newValue);
          }}
          showLabels
          className={classes.navigation}
        >
          {HREF.map((value, index) => (
            <StyledBottomNavigationAction
              key={index}
              label={<span data-lang={value.key}>{value.name}</span>}
              onClick={() => {
                if (value.internal) {
                  history.push(value.url);
                } else {
                  window.open(value.url, "_blank");
                }
              }}
              className={classes.bottomNavigationAction}
            />
          ))}
        </BottomNavigation>
      </Grid>
      <Grid
        container
        item
        md={2}
        lg={3}
        direction="row"
        justify="flex-start"
        alignItems="center"
        // spacing={2}
        // className="pt-3"
      >
        <Grid
          container
          direction="row"
          item
          md={12}
          lg={6}
          justify="center"
          alignItems="center"
        >
          <Grid item md={3} style={{ textAlign: "center" }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://m.facebook.com/ilusionamaskebowling/"
            >
              <FacebookIcon
                fontSize="default"
                style={{ color: "white", cursor: "pointer" }}
              />
            </a>
          </Grid>
          <Grid item md={3} style={{ textAlign: "center", cursor: "pointer" }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/ilusionamaskebowling/"
            >
              <InstagramIcon fontSize="default" style={{ color: "white" }} />
            </a>
          </Grid>
          <Grid item md={3} style={{ textAlign: "center", cursor: "pointer" }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCXHpHJ78EBvZsjBNrU4VSfg/"
            >
              <YouTubeIcon fontSize="default" style={{ color: "white" }} />
            </a>
          </Grid>
        </Grid>
        <Grid
          container
          item
          md={12}
          lg={6}
          justify="center"
          alignItems="center"
        >
          <Box my="auto" style={{overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis", color: "white"}} data-lang-html="hello_user" data-lang-vars={JSON.stringify({name: user.name})}>Hola, {user.name}!</Box>
          <Grid item md={3} style={{ textAlign: "center" }}>
            <ExitToAppIcon
              style={{ color: "white", paddingLeft: "5px", cursor: "pointer" }}
              onClick={onClickLogout}
            />
          </Grid>
          <Grid item md={3} style={{ textAlign: "center" }}>
            <LangSelector />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withRouter(FullWidthTabs);
